import { useMemo, useRef } from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const useBarnsWithHorses = (horses: racehorse360.IHorse[]) => {
  const barnsRef = useRef<Record<string, boolean>>({});

  return useMemo(() => {
    const barns: Record<string, boolean> = {};

    (horses || []).forEach(horse => {
      if (horse.barn?.name) barns[horse.barn.name.toLowerCase()] = true;
    });

    const prevBarns = barnsRef.current;
    const prevKeys = Object.keys(prevBarns);
    const nextKeys = Object.keys(barns);
    const isSame =
      prevKeys.length === nextKeys.length &&
      nextKeys.every(key => prevBarns[key] === barns[key]);

    if (isSame) return prevBarns;

    barnsRef.current = barns;
    return barns;
  }, [horses]);
};
